export default "__VITE_ASSET__CXMXoW0s__"